import { useAppSelector } from 'src/store';
import {
  getIntegrationCatalog,
  type IntegrationCatalogEntry,
} from 'src/components/Integrations/IntegrationTypes';
import { AddIntegrationListItem } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationListItem';
import AddZendeskIcon from 'src/assets/img/add-integration/add-integration-zendesk-icon.svg';
import AddZohoChatIcon from 'src/assets/img/add-integration/add-integration-zoho-chat-icon.svg';
import AddZohoEmailIcon from 'src/assets/img/add-integration/add-integration-zoho-email-icon.svg';
import AddZendeskChatIcon from 'src/assets/img/add-integration/add-integration-zendesk-chat-icon.svg';
import AddZendeskEmailIcon from 'src/assets/img/add-integration/add-integration-zendesk-email-icon.svg';
import AddFreshdeskIcon from 'src/assets/img/add-integration/add-integration-freshdesk-icon.svg';
import AddFreshdeskChatIcon from 'src/assets/img/add-integration/add-integration-freshdesk-chat.svg';
import AddFreshdeskEmailIcon from 'src/assets/img/add-integration/add-integration-freshdesk-email.svg';
import AddSlackIcon from 'src/assets/img/add-integration/add-integration-slack-icon.svg';
import AddTrengoIcon from 'src/assets/img/add-integration/add-integration-trengo-icon.svg';
import { useTheme } from 'src/provider/ThemeProvider';
import { clsx } from 'clsx';
import type { Project } from 'src/services/projectsService';

export const AddIntegrationList = ({
  project,
  onClick,
}: {
  project: Pick<Project, 'name' | 'integrations'>;
  onClick: (integrationType: IntegrationCatalogEntry) => void;
}) => {
  const { config } = useTheme();
  const { projectType } = useAppSelector((s) => s.projectsSlices);

  const integrationTypes = getIntegrationCatalog(projectType);

  return (
    <div className="content">
      <div className="sub-title">
        <h4>Available tools:</h4>
      </div>
      <ul className={clsx('add-integration-list', config.className)}>
        {integrationTypes?.map((integrationType) => {
          const type = integrationType.data.integration_type;
          const isExist = project.integrations.some(
            (integration) => integration.integration_type === type,
          );

          if (isExist) {
            return null;
          }

          switch (type) {
            case 'zendesk':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddZendeskIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'zoho_salesiq':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddZohoChatIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'zoho_desk':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddZohoEmailIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'zendesk_chat':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddZendeskChatIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'zendesk_email':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddZendeskEmailIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'freshdesk':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddFreshdeskIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'freshdesk_chat':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddFreshdeskChatIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'freshdesk_email':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddFreshdeskEmailIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            case 'slack': {
              const request = { ...integrationType };

              request.data.integration_data.project_name = project.name;
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddSlackIcon}
                  name={'Slack'}
                  onClick={() => onClick(request)}
                />
              );
            }
            case 'trengo':
              return (
                <AddIntegrationListItem
                  key={type}
                  icon={AddTrengoIcon}
                  name={integrationType.friendlyName}
                  onClick={() => onClick(integrationType)}
                />
              );
            default:
              return null;
          }
        })}
      </ul>
    </div>
  );
};
